import React, { FC } from 'react';
import Container from 'react-bootstrap/Container';
import { graphql } from 'gatsby';
import classNames from 'classnames';

import DangerouslySetInnerHtml from 'components/common/DangerouslySetInnerHtml';
import UniversalImage from 'components/common/UniversalImage';

import { IWhyNurofenTextComponentProps } from './model';

import './WhyNurofenText.scss';

const WhyNurofenText: FC<IWhyNurofenTextComponentProps> = ({
  textboxText,
  textboxBgColor,
  textboxImage,
  textboxImageAlt,
  textboxBulletsColor,
}) => {
  const bulletsColorLabel = textboxBulletsColor?.[0]?.properties?.colorPicker?.label;
  const bulletsColor = bulletsColorLabel ? `${bulletsColorLabel}-default-bg` : '';
  const listDotClasses = classNames('why-nurofen-text__content', {
    [bulletsColor]: bulletsColor,
  });

  return (
    <div
      className="why-nurofen-text"
      data-test="WhyNurofenText"
      style={
        textboxBgColor &&
        ({
          backgroundColor: `var(--${textboxBgColor?.[0]?.properties?.colorPicker?.label})`,
        } as React.CSSProperties)
      }
    >
      <Container fluid>
        <div className={listDotClasses}>
          <DangerouslySetInnerHtml html={textboxText} />
        </div>
        {textboxImage ? (
          <div className="why-nurofen-text__img">
            <UniversalImage imageAlt={textboxImageAlt} img={textboxImage} />
          </div>
        ) : null}
      </Container>
    </div>
  );
};

export const query = graphql`
  fragment FragmentTextbox on ITextbox {
    textboxText
    textboxImage {
      fallbackUrl
      url
      gatsbyImage {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      svg {
        content
      }
    }
    textboxImageAlt
    textboxBgColor {
      ...FragmentColorProps
    }
    textboxBulletsColor {
      ...FragmentColorProps
    }
  }
`;

export default WhyNurofenText;
